import React from 'react';
import bottomImage from '../assets/images/footer-contact.png';

function BottomSection() {
  return (
    <>
      <section className="global-bottom-section">
        <img className="global-bottom-image" src={bottomImage} alt="价探底部联系方式展示" />

        <div className="bottom-brand-overlay">
          <p className="bottom-brand-title" style={{ marginTop: '10%' }}>
            <span className="bottom-brand-cn">价探</span>
            <span className="bottom-brand-en">PriceTag</span>
          </p>
          <p className="bottom-brand-line" style={{ marginTop: '-7%' }}>加盟热线:4001-727-117</p>
          <p className="bottom-brand-line" style={{ marginTop: '-0%' }}>加盟邮箱:Carrie@jiatanpricetag.com</p>
        </div>
      </section>

      <footer className="site-footer">
        <p className="site-footer-text">
          <span>Copyright © 2026，上海蜜田科技有限公司 </span>
          <a
            className="site-footer-link"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener noreferrer"
          >
            沪ICP备18011516号-1
          </a>
        </p>
      </footer>
    </>
  );
}

export default BottomSection;
